<template>
	<div>
		<v-container>
			<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>

			<v-card :loading="loading">
				<v-card-text class="text-h5 text-center pa-4">أنواع المحتويات في المكتبة الطبية</v-card-text>
				<v-card-text>
					<v-form v-model="valid">
						<v-row>
							<template v-for="(type, index) in types">
								<v-col :key="index" cols="10" sm="11" class="pa-2">
									<v-text-field
										v-model="type.value"
										outlined
										hide-details="auto"
										:label="'#' + (index+1)"
										:rules="[rules.required]"
									></v-text-field>
								</v-col>
								<v-col :key="index+'1'" cols="2" sm="1" class="pa-2 pt-5">
									<v-btn icon @click="removeType(index)">
										<v-icon color="red">mdi-close-circle</v-icon>
									</v-btn>
								</v-col>
							</template>
							<v-col cols="12" class="pa-2">
								<v-btn color="primary" :disabled="loading" @click="addNewType">
									إضافة نوع محتوى جديد
									<v-icon right>mdi-plus</v-icon>
								</v-btn>
							</v-col>
							<v-col cols="12" class="text-center">
								<v-btn
									color="success"
									:disabled="loading || types.length == 0 || !valid"
									:loading="submitting"
									@click="saveTypes"
								>
									حفظ
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";

export default {
	mixins: [require("@/mixins/router-mixin").default, rulesMixin],
	data() {
		return {
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					to: { name: "dashboard-home" }
				},
				{
					text: "المكتبة الطبية",
					exact: true,
					to: { name: "dashboard-library" }
				},
				{
					text: "أنواع المحتويات في المكتبة الطبية",
					disabled: true
				}
			],
			valid: false,
			types: null,
			loading: true,
			submitting: false
		};
	},
	mounted() {
		this.getTypes();
	},
	methods: {
		getTypes() {
			client
				.get("/api/library/types")
				.then(response => {
					this.loading = false;
					this.types = response.data.map(type => {
						type = { value: type };
						return type;
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		saveTypes() {
			var data = {
				libraryTypes: this.types.map(type => type.value)
			};
			this.submitting = true;

			client
				.post("/api/library/updateTypes", data)
				.then(response => {
					this.submitting = false;
					this.$store.dispatch("notify", {
						message: response.data.message || "تم الحفظ"
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addNewType() {
			this.types.push({ value: "" });
		},
		removeType(index) {
			this.types.splice(index, 1);
		}
	}
};
</script>